export default {"src":"/_next/static/media/image.b74f4fee.svg","height":86,"width":319,"blurWidth":0,"blurHeight":0};